// Projects module — shared enums, badge palettes and helpers (Projects P1).
// Enum values mirror backend /api/projects/meta; badges follow the ERP tinted-chip convention.

export const PROJECT_STATUS_BADGES = {
  Draft: 'bg-slate-50 text-slate-600 border-slate-200',
  'Awaiting Onboarding': 'bg-amber-50 text-amber-800 border-amber-200',
  Onboarding: 'bg-sky-50 text-sky-700 border-sky-200',
  'Ready to Start': 'bg-indigo-50 text-indigo-700 border-indigo-200',
  'In Progress': 'bg-blue-50 text-blue-700 border-blue-200',
  'On Hold': 'bg-orange-50 text-orange-700 border-orange-200',
  Blocked: 'bg-red-50 text-red-600 border-red-200',
  'Awaiting Client': 'bg-violet-50 text-violet-700 border-violet-200',
  'Under Review': 'bg-cyan-50 text-cyan-700 border-cyan-200',
  Extended: 'bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200',
  Completed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Cancelled: 'bg-red-50 text-red-600 border-red-200',
  Closed: 'bg-slate-100 text-slate-600 border-slate-200',
  Archived: 'bg-slate-100 text-slate-500 border-slate-200',
};

export const HEALTH_DOTS = {
  Green: 'bg-emerald-500',
  Amber: 'bg-amber-500',
  Red: 'bg-red-500',
  Grey: 'bg-slate-400',
};

export const HEALTH_BADGES = {
  Green: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Amber: 'bg-amber-50 text-amber-800 border-amber-200',
  Red: 'bg-red-50 text-red-600 border-red-200',
  Grey: 'bg-slate-50 text-slate-600 border-slate-200',
};

export const TASK_STATUS_BADGES = {
  'To Do': 'bg-slate-50 text-slate-600 border-slate-200',
  Scheduled: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  'In Progress': 'bg-blue-50 text-blue-700 border-blue-200',
  Blocked: 'bg-red-50 text-red-600 border-red-200',
  'On Hold': 'bg-orange-50 text-orange-700 border-orange-200',
  'Awaiting Client': 'bg-violet-50 text-violet-700 border-violet-200',
  'Under Review': 'bg-cyan-50 text-cyan-700 border-cyan-200',
  'Rework Required': 'bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200',
  Completed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Cancelled: 'bg-red-50 text-red-500 border-red-200',
  Reopened: 'bg-amber-50 text-amber-800 border-amber-200',
};

export const PRIORITY_BADGES = {
  Low: 'bg-slate-50 text-slate-600 border-slate-200',
  Medium: 'bg-sky-50 text-sky-700 border-sky-200',
  High: 'bg-amber-50 text-amber-800 border-amber-200',
  Urgent: 'bg-red-50 text-red-600 border-red-200',
};

export const SERVICE_STATUS_BADGES = {
  'Not Started': 'bg-slate-50 text-slate-600 border-slate-200',
  Onboarding: 'bg-sky-50 text-sky-700 border-sky-200',
  'In Progress': 'bg-blue-50 text-blue-700 border-blue-200',
  'On Hold': 'bg-orange-50 text-orange-700 border-orange-200',
  Blocked: 'bg-red-50 text-red-600 border-red-200',
  'Under Review': 'bg-cyan-50 text-cyan-700 border-cyan-200',
  Completed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Cancelled: 'bg-red-50 text-red-500 border-red-200',
};

export const MILESTONE_STATUS_BADGES = {
  Planned: 'bg-slate-50 text-slate-600 border-slate-200',
  'In Progress': 'bg-blue-50 text-blue-700 border-blue-200',
  Achieved: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Missed: 'bg-red-50 text-red-600 border-red-200',
  Cancelled: 'bg-red-50 text-red-500 border-red-200',
};

export const DELIVERABLE_STATUS_BADGES = {
  Draft: 'bg-slate-50 text-slate-600 border-slate-200',
  'In Progress': 'bg-blue-50 text-blue-700 border-blue-200',
  'Internal Review': 'bg-cyan-50 text-cyan-700 border-cyan-200',
  'Client Review': 'bg-violet-50 text-violet-700 border-violet-200',
  Approved: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Rework Required': 'bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200',
  Delivered: 'bg-emerald-50 text-emerald-800 border-emerald-200',
};

export const EXTRA_WORK_BADGES = {
  Requested: 'bg-slate-50 text-slate-600 border-slate-200',
  'Under Review': 'bg-cyan-50 text-cyan-700 border-cyan-200',
  Approved: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Rejected: 'bg-red-50 text-red-600 border-red-200',
  'In Progress': 'bg-blue-50 text-blue-700 border-blue-200',
  Completed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Sent to Accounts': 'bg-violet-50 text-violet-700 border-violet-200',
  Billed: 'bg-emerald-100 text-emerald-800 border-emerald-300',
  Cancelled: 'bg-red-50 text-red-500 border-red-200',
};

export const BILLING_REQUEST_BADGES = {
  Pending: 'bg-amber-50 text-amber-800 border-amber-200',
  Processed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Rejected: 'bg-red-50 text-red-600 border-red-200',
};

// ---------------------------------------------------------------- dynamic status engine helpers

export const DEFAULT_STATUS_COLOR = '#64748b';

/** Preset swatches for the status colour picker (rich, modern shades). */
export const STATUS_COLOR_PRESETS = [
  '#64748b', '#2563eb', '#0284c7', '#0e7490', '#4f46e5', '#7c3aed',
  '#c026d3', '#dc2626', '#ea580c', '#d97706', '#059669', '#16a34a',
];

/** Human labels for immutable system categories. */
export const CATEGORY_LABELS = {
  DRAFT: 'Draft', ONBOARDING: 'Onboarding', PLANNED: 'Planned', ACTIVE: 'Active',
  WAITING: 'Waiting', REVIEW: 'Review', ON_HOLD: 'On Hold', COMPLETED: 'Completed',
  CANCELLED: 'Cancelled', CLOSED: 'Closed',
  NOT_STARTED: 'Not Started', IN_PROGRESS: 'In Progress', WAITING_BLOCKED: 'Waiting / Blocked',
};

/** Tinted chip classes per system category (used in the status manager). */
export const CATEGORY_BADGES = {
  DRAFT: 'bg-slate-50 text-slate-600 border-slate-200',
  ONBOARDING: 'bg-sky-50 text-sky-700 border-sky-200',
  PLANNED: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  ACTIVE: 'bg-blue-50 text-blue-700 border-blue-200',
  WAITING: 'bg-violet-50 text-violet-700 border-violet-200',
  REVIEW: 'bg-cyan-50 text-cyan-700 border-cyan-200',
  ON_HOLD: 'bg-orange-50 text-orange-700 border-orange-200',
  COMPLETED: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  CANCELLED: 'bg-red-50 text-red-600 border-red-200',
  CLOSED: 'bg-slate-100 text-slate-600 border-slate-200',
  NOT_STARTED: 'bg-slate-50 text-slate-600 border-slate-200',
  IN_PROGRESS: 'bg-blue-50 text-blue-700 border-blue-200',
  WAITING_BLOCKED: 'bg-orange-50 text-orange-700 border-orange-200',
};

/** Hex colour → tinted chip inline style (8% bg, 25% border, solid text). */
export const statusChipStyle = (color) => {
  const c = color || DEFAULT_STATUS_COLOR;
  return { backgroundColor: `${c}14`, color: c, borderColor: `${c}40` };
};

/** Find the status def for an entity — by immutable status_id first, then label. */
export const findStatusDef = (defs, entity) => {
  if (!defs?.length || !entity) return null;
  return defs.find((d) => d.id === entity.status_id) || defs.find((d) => d.label === entity.status) || null;
};

export const findDefById = (defs, id) => (defs || []).find((d) => d.id === id) || null;

/** Resolve the immutable system category of an entity's status. */
export const statusCategoryOf = (entity, defs) =>
  entity?.status_category || findStatusDef(defs, entity)?.category || null;

/** Human-readable API error (handles structured 409 payloads). */
export const apiError = (err, fallback = 'Something went wrong') => {
  const d = err?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === 'string') return d;
  if (d.message) return d.message;
  return fallback;
};
